<!-- 登录注册时选择国家码的组件 -->
<template>
  <div
    :class="[
      'CountrySelect-Component',
      { 'CountrySelect-Component-active': countryListBoxVisible }
    ]"
    @click="countryListBoxVisible = !countryListBoxVisible"
  >
    <p class="current_selected">{{ countryName }}</p>
    <div v-show="countryListBoxVisible" class="country_list_box">
      <ul class="country_list">
        <li
          v-for="(countryData, index) in numberCodeList"
          :key="index"
          @click="clickCountrySelect(countryData)"
        >
          <span class="country_name" v-text="countryData.country_name" />
          <span class="country_number" v-text="'+' + countryData.phone_code" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */

export default {
  components: {},
  data() {
    return {
      countryName: '',
      countryListBoxVisible: false,
      numberCodeList: null
    };
  },
  computed: {},
  created() {
    this.$api.getCountryInfoList().then((res) => {
      if (res) {
        this.numberCodeList = res;
      }
    });

    this.initUserCountry();
  },
  methods: {
    initUserCountry() {
      if (!localStorage) {
        return;
      }
      const {
        yourCountryCode,
        yourCountryName,
        yourPhonePrevCode
      } = localStorage;

      if (yourCountryCode) {
        this.countryName = yourCountryName;

        this.$emit('on-change', {
          countryName: yourCountryName,
          countryCode: yourCountryCode,
          phonePrevCode: yourPhonePrevCode
        });
      }
    },
    clickCountrySelect(countryInfo) {
      const { country_code } = countryInfo;
      const countryName = this.numberCodeList[country_code].country_name;
      const countryCode = country_code;
      const phonePrevCode = this.numberCodeList[countryCode].phone_code;

      this.countryName = countryName;
      this.$emit('on-change', { countryName, countryCode, phonePrevCode });

      if (localStorage) {
        localStorage.yourCountryCode = countryCode;
        localStorage.yourCountryName = countryName;
        localStorage.yourPhonePrevCode = phonePrevCode;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.CountrySelect-Component {
  position: relative;
  z-index: 9;
  color: #3a5161;
  height: 40px;
  background: #f5f7fa;
  border-radius: 20px;
  // border: 1px solid #00decb;

  &.CountrySelect-Component-active {
    border: 1px solid #00decb;

    .current_selected {
      &::after {
        background-image: url('~@assets/img/up_arrow_green.png');
      }
    }
  }
}

.current_selected {
  display: block;
  position: relative;
  line-height: 38px;
  text-indent: 14px;
  cursor: pointer;
  text-align: left;

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 16px;
    top: 14px;
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('~@assets/img/login/down_icon.png');
  }
}

.country_list_box {
  position: absolute;
  left: -1px;
  right: -1px;
  top: 40px;
  padding-top: 5px;

  & ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 8px;
    display: none;
  }

  & ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
  }

  & ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #d6e3e8;
  }

  & ::-webkit-scrollbar-button {
    height: 4px;
    width: 4px;
    background: transparent;
  }
}

.country_list {
  border-radius: 3px;
  max-height: 250px;
  overflow: auto;
  background: #fff;
  border: 1px #a3ccc9 solid;

  li {
    display: block;
    overflow: hidden;
    height: 28px;
    line-height: 28px;
    cursor: pointer;
  }

  .country_name {
    // font-size: 14px;
    // color: #3a5161;
    float: left;
    margin-left: 10px;
  }

  .country_number {
    font-size: 14px;
    color: #8ba8b4;
    float: right;
    margin-right: 20px;
  }

  li:hover .country_name {
    color: #0dc;
  }
}
</style>
